import PropTypes from "prop-types";
import React, { Component } from "react";
import "./styles.scss";
import "react-table-v6/react-table.css";
import selectTableHOC from "react-table/lib/hoc/selectTable";
import PropTypes from "prop-types";
import Table from "react-table";
import ReactTable from "react-table-v6";
import "react-table-v6/react-table.css";
import PlaylistPreviewLink from "../../components/PlaylistPreviewLink";
import { Icon } from "../widgets";
import deleteImg from "signoxe/images/delete.png";
import duplicateImg from "signoxe/images/duplicate.png";
import editImg from "signoxe/images/edit.png";
import previewImg from "signoxe/images/preview.png";
import { Link } from "react-router-dom/es";

const SelectTable = selectTableHOC(Table);

class ChannelList extends Component {
  static defaultProps = {
    keyField: "id",
  };

  static propTypes = {
    keyField: PropTypes.string,
  };

  static propTypes = {
    handleToggleAll: PropTypes.func.isRequired,
    channels: PropTypes.array.isRequired,
    selectAll: PropTypes.array.isRequired,
    columns: PropTypes.array.isRequired,
    tableProps: PropTypes.array.isRequired,
    checkedIsSelected: PropTypes.array.isRequired,
    refKey: PropTypes.array.isRequired,
    toggleSelection: PropTypes.array.isRequired,
    editing: PropTypes.array.isRequired,
  };

  render() {
    const {
      toggleSelection,
      handleToggleAll,
      refKey,
      checkedIsSelected,
      tableProps,
      onDelete,
      renderEditable,
      onClone,
      onToggleEdit,
    } = this.props;

    const { channels, isLoading, selectAll, editing } = this.props;

    const defaultColumns = [
      {
        Header: () => (
          <div>
            {" "}
            <i className="fas fa-caret-down mr-1"></i> Name{" "}
          </div>
        ),
        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
        accessor: "name",
      },
      {
        Header: () => (
          <div>
            {" "}
            <i className="fas fa-caret-down mr-1"></i> Orientation{" "}
          </div>
        ),
        headerStyle: {
          textAlign: "left",
          maxWidth: "content",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
      },
      {
        Header: () => (
          <div>
            {" "}
            <i className="fas fa-caret-down mr-1"></i> No of Regions{" "}
          </div>
        ),
        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
      },

      {
        Header: () => <div></div>,
        sortable: false,
        filterable: false,

        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
      },
    ];

    const columns = [
      {
        Header: () => (
          <div>
            {" "}
            <i className="fas fa-caret-down mr-1"></i> Name{" "}
          </div>
        ),

        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },

        accessor: "name",
        Cell: renderEditable,

        style: {
          textAlign: "left",
          border: "1px solid transparent",
        },
      },

      {
        Header: () => (
          <div className="hide-for-mobile">
            {" "}
            <i className="fas fa-caret-down mr-1"></i> Orientation{" "}
          </div>
        ),
        // sortable: true,
        // filterable: true,
        accessor: "aspect_ratio",

        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
      },
      {
        Header: () => (
          <div>
            {" "}
            <i className="fas fa-caret-down mr-1"></i> No of Regions
          </div>
        ),
        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
        accessor: "regions.length",

        style: {
          textAlign: "left",
          border: "1px solid transparent",
        },
      },

      {
        Header: () => <div></div>,
        sortable: false,
        filterable: false,

        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
        style: {
          textAlign: "right",
          border: "1px solid transparent",
        },

        Cell: (props) => {
          return (
            <div class="d-flex align-items-center">
              <span
                title="Create a Clone"
                className="custom-icon mr-1"
                onClick={() => {
                  onClone(props.original);
                }}
              >
                {" "}
                <img
                  src={duplicateImg}
                  alt="..."
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    width: "auto",
                  }}
                  className="action-icon"
                />
              </span>
              <span
                title="Edit Channel"
                className="custom-icon"
                onClick={onToggleEdit}
              >
                {" "}
                <img
                  src={editImg}
                  alt="..."
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    width: "auto",
                  }}
                  className="action-icon"
                />
              </span>
              <span
                title="Delete"
                className="custom-icon mr-1"
                onClick={() => {
                  onDelete(props.original);
                }}
              >
                <i className="fas fa-trash-o"></i>
              </span>
            </div>
          );
        },
      },
    ];

    const mobileColumns = [
      {
        Header: () => (
          <div>
            {" "}
            <i className="fas fa-caret-down mr-1"></i> Name{" "}
          </div>
        ),
        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
        accessor: "name",
        Cell: renderEditable,

        style: {
          textAlign: "left",
          border: "1px solid transparent",
        },
      },
      {
        Header: () => (
          <div>
            {" "}
            <i className="fas fa-caret-down mr-1"></i> Regions{" "}
          </div>
        ),
        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
        accessor: "regions.length",

        style: {
          textAlign: "center",
          border: "1px solid transparent",
        },
      },
      {
        Header: () => <div></div>,
        sortable: false,
        filterable: false,

        headerStyle: {
          textAlign: "left",
          border: "1px solid transparent",
          "border-bottom-color": "grey",
        },
        style: {
          textAlign: "right",
          border: "1px solid transparent",
        },

        Cell: (props) => {
          return (
            <div class="d-flex align-items-center">
              <span
                title="Create a Clone"
                className="custom-icon mr-1"
                onClick={() => {
                  onClone(props.original);
                }}
              >
                {" "}
                <img
                  src={duplicateImg}
                  alt="..."
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    width: "auto",
                  }}
                  className="action-icon"
                />
              </span>
              <span
                title="Edit Channel"
                className="custom-icon"
                onClick={onToggleEdit}
              >
                {" "}
                <img
                  src={editImg}
                  alt="..."
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    width: "auto",
                  }}
                  className="action-icon"
                />
              </span>
              <span
                title="Delete"
                className="custom-icon mr-1"
                onClick={() => {
                  onDelete(props.original);
                }}
              >
                <i className="fas fa-trash-o"></i>
              </span>
            </div>
          );
        },
      },
    ];
    return (
      <React.Fragment>
        {channels && channels.length !== 0 ? (
          <div>
            <div className="hide-for-mobile">
              {editing ? (
                <SelectTable
                  keyField="id"
                  columns={columns}
                  data={channels}
                  defaultPageSize={10}
                  noDataText={"Loading channels .."}
                  loading={isLoading}
                  ref={refKey}
                  toggleSelection={toggleSelection}
                  selectAll={selectAll}
                  selectType="checkbox"
                  toggleAll={handleToggleAll}
                  isSelected={checkedIsSelected}
                  getTrProps={tableProps}
                />
              ) : (
                <ReactTable
                  columns={columns}
                  data={channels}
                  defaultPageSize={10}
                  noDataText={"Loading channels .."}
                  loading={isLoading}
                />
              )}
            </div>

            <div className="hide-for-desktop">
              {editing ? (
                <SelectTable
                  keyField="id"
                  columns={mobileColumns}
                  data={channels}
                  defaultPageSize={10}
                  noDataText={"Loading channels .."}
                  loading={isLoading}
                  ref={refKey}
                  toggleSelection={toggleSelection}
                  selectAll={selectAll}
                  selectType="checkbox"
                  toggleAll={handleToggleAll}
                  isSelected={checkedIsSelected}
                  getTrProps={tableProps}
                />
              ) : (
                <ReactTable
                  columns={mobileColumns}
                  data={channels}
                  defaultPageSize={10}
                  noDataText={"Loading channels .."}
                  loading={isLoading}
                />
              )}
            </div>
          </div>
        ) : (
          <ReactTable
            columns={defaultColumns}
            defaultPageSize={10}
            noDataText={"Loading Channels .."}
            loading={isLoading}
            showPagination={false}
          />
        )}
      </React.Fragment>
    );
  }
}

ChannelList.propTypes = {
  channels: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired,
  onClone: PropTypes.func.isRequired,
  handleToggleAll: PropTypes.func.isRequired,
  checkedIsSelected: PropTypes.func.isRequired,
  tableProps: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  selectAll: PropTypes.func.isRequired,
  refKey: PropTypes.func.isRequired,
  toggleSelection: PropTypes.func.isRequired,
  editing: PropTypes.func.isRequired,
};

export default ChannelList;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/ChannelList/index.js